import React from 'react';
import {t} from '@lingui/core/macro';

import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

import styles from './HttpMonitorActions.module.scss';

interface IHttpMonitorActionsProps {
    item: IHttpMonitorItem;
}

const HttpMonitorActions: React.FC<IHttpMonitorActionsProps> = ({item}) => {
    const findOptionLabel = (
        options: {label: string, value: string}[],
        value: string | number | undefined,
    ): string => options.find(option => option.value === value)?.label ?? '-';

    const notifyLogicLabel = (logic: string | number | undefined) => findOptionLabel([
        {label: ` ${t`Уведомить, если присутствуют`}`, value: 'present'},
        {label: ` ${t`Уведомить, если отсутствуют`}`, value: 'not-present'},
    ], logic);

    const contentLogicLabel = (logic: string | number | undefined) => findOptionLabel([
        {label: t`И`, value: 'and'},
        {label: t`ИЛИ`, value: 'or'},
    ], logic);

    const renderParseErrors = () => {
        if (!item.parse_errors) return t`Отключено`;

        return (
            <>
                {t`Включено`}
                {item.parse_errors_type === 'json' && (
                    <p>{item.parse_errors_type}: {item.parse_errors_pattern}</p>
                )}
                {item.parse_errors_type === 'regexp' && (
                    <p>{t`Регулярное выражение`}: {item.parse_errors_pattern}</p>
                )}
            </>
        );
    };

    const renderContentCheck = () => {
        if (!item.monitor_content_enabled) return t`Отключено`;

        return (
            <>
                <span>{item.monitor_content_data}</span>
                <p>
                    {t`Логика`} {contentLogicLabel(item.monitor_content_logic)}
                    {notifyLogicLabel(item.monitor_content_notify_logic)}
                </p>
            </>
        );
    };

    return (
        <div className={styles.actions}>
            <span>
                {t`Учащенный мониторинг`}: {item.frequent_checking ? t`Включено` : t`Отключено`}
            </span>
            <span>
                {t`Разбор проблем`}: {renderParseErrors()}
            </span>
            <span>
                {t`Проверка контента страницы`}: {renderContentCheck()}
            </span>
            <span>
                {t`Скриншот страницы ошибки`}: {item.screenshot_on_error ? t`Включено` : t`Отключено`}
            </span>
        </div>
    );
};

export default HttpMonitorActions;